import * as base from './base';
import { log } from './log';
const produceUndefinedFuncError = (functionName) => new Error(`${functionName} was undefined`);
const produceUnsupportedClientError = () => new Error('unsupported client');
const invokeAndroid = ({ functionName, params }) => {
    return new Promise((resolve, reject) => {
        const m2w = window.m2w;
        if (!m2w || !m2w[functionName]) {
            reject(produceUndefinedFuncError(functionName));
            return;
        }
        // 貌似安卓参数中传输不了js json对象
        if (params) {
            resolve(m2w[functionName](params));
        }
        else {
            resolve(m2w[functionName]());
        }
    });
};
const invokeIos = ({ functionName, params }) => {
    return new Promise((resolve, reject) => {
        var _a, _b;
        const callbackName = `WearableTemp${functionName}`;
        window[callbackName] = (value) => {
            window[callbackName] = undefined;
            resolve(value);
        };
        const webkit = window.webkit;
        if (!((_b = (_a = webkit) === null || _a === void 0 ? void 0 : _a.messageHandlers) === null || _b === void 0 ? void 0 : _b[functionName])) {
            reject(produceUndefinedFuncError(functionName));
            return;
        }
        webkit.messageHandlers[functionName].postMessage({ callbackName, params });
    });
};
const invoke = (config) => {
    if (base.isAndroid) {
        log(config);
        return invokeAndroid(config);
    }
    else if (base.isIos) {
        log(config);
        return invokeIos(config);
    }
    else {
        return Promise.reject(produceUnsupportedClientError());
    }
};
export default {
    invokeAndroid,
    invokeIos,
    invoke,
};
//# sourceMappingURL=data:application/json;base64,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